import { AspectRatio, Card, Flex, Image, Stack, Title, useMatches } from "@mantine/core";
import { Link } from "react-router";

import classes from "./MakeCard.module.css";
import { getLogoFromMake } from "./utils";

import { paths } from "@/config/paths";

import type { MakeName } from "@/types/make";
import type { MantineStyleProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

export type MakeCardProps = {
  id?: string;
  /**
   * Component to render if no logo or make is provided or found
   */
  FallbackComponent?: ReactNode;
  hideBG?: boolean;
  make: MakeName;
  marketCard?: boolean;
  showMake?: boolean;
} & MantineStyleProps;

export const MakeCard: FC<MakeCardProps> = ({
  id,
  hideBG = false,
  FallbackComponent,
  make,
  marketCard = false,
  showMake,
  ...props
}) => {
  const logo = getLogoFromMake(make);
  const isMobile = useMatches({ base: true, md: false });

  const content = (
    <>
      {logo && (
        <AspectRatio w="3.5em" className={!hideBG ? classes.logoContainer : undefined}>
          <Image src={logo} fit="contain" className={classes.logo} alt={make} aria-label={make} />
        </AspectRatio>
      )}
      {showMake && (
        <Title order={5} lineClamp={1} title={make}>
          {make}
        </Title>
      )}
    </>
  );

  if (marketCard) {
    const marketContent = isMobile ? (
      <Card p={10} h="100%" w="100%" display="inline-flex">
        <Flex justify="center" align="center" h="100%" gap="md" w="100%" maw="150px" m="0 auto">
          {logo && (
            <AspectRatio ratio={1} w={30}>
              <Image
                src={logo}
                fit="contain"
                className={classes.logo}
                alt={make}
                aria-label={make}
              />
            </AspectRatio>
          )}
          {showMake && (
            <Title order={5} lineClamp={1} title={make} pr={10}>
              {make}
            </Title>
          )}
        </Flex>
      </Card>
    ) : (
      <AspectRatio h="100%" className={classes.card}>
        <Card p={22} h="100%" className={classes.card}>
          <Stack align="center" justify="center" h="100%">
            {content}
          </Stack>
        </Card>
      </AspectRatio>
    );

    if (id) {
      return (
        <Link to={paths.app.markets.makeDetails.getHref(id)} className={classes.link}>
          {marketContent}
        </Link>
      );
    }
    return marketContent;
  }

  return logo || showMake ? (
    <Stack align="center" className={classes.rootContainer} {...props}>
      {content}
    </Stack>
  ) : (
    FallbackComponent
  );
};
